import { FiltersPlugins, useGuiFilters } from "@me8eon/filters";
import { SearchTextFilter, searchTextFilterPlugin, searchTextName } from "@me8eon/searchtext_filters";
import { timeFilterPlugin, timefilterPluginName, TimeFilters } from "@me8eon/time_filters";
import { makeUseStateChild } from "@me8eon/context";
import { aggregateFilterName, aggregateFilterPlugin } from "@me8eon/aggregate_filters";
import { mimeTypeFilterPlugin, mimeTypeFilterPluginName, MimeTypeFilters } from "@me8eon/mimetype_filter";
import { departmentTypeFilterPlugin, departmentTypeFilterPluginName, DepartmentTypeFilters } from "@me8eon/departmenttype_filter";
import { dataViewFilterPlugin, DataViewFilters } from "@me8eon/data_view_filter";
import { dataViewFilterName } from "@me8eon/data_views";
import { companyFilterPlugin, companyfilterPluginName, CompanyFilters } from "@me8eon/company_filters";
import { radioFilterName, radioFilterPlugin } from "@me8eon/radio_filters";

export type AllFilters = SearchTextFilter & TimeFilters & MimeTypeFilters & DataViewFilters & DepartmentTypeFilters & CompanyFilters;

/**
 * A collection of filter plugins used in the application.
 *
 * This object maps filter plugin names to their respective implementations.
 * Each plugin is responsible for handling a specific type of filtering logic.
 *
 * @type {FiltersPlugins<AllFilters>}
 *
 * @property {typeof searchTextFilterPlugin} [searchTextName] - Plugin for handling search text filtering.
 * @property {typeof timeFilterPlugin} [timefilterPluginName] - Plugin for handling time-based filtering.
 * @property {typeof aggregateFilterPlugin} [aggregateFilterName] - Plugin for handling aggregate filtering.
 * @property {typeof radioFilterPlugin} [radioFilterName] - Plugin for handling radio filtering.
 */
export const allFilters: FiltersPlugins<AllFilters> = {
    [searchTextName]: searchTextFilterPlugin,
    [timefilterPluginName]: timeFilterPlugin,
    [aggregateFilterName as any]: aggregateFilterPlugin,
    [mimeTypeFilterPluginName]: mimeTypeFilterPlugin,
    [departmentTypeFilterPluginName]: departmentTypeFilterPlugin,
    [dataViewFilterName]: dataViewFilterPlugin,
    [companyfilterPluginName]: companyFilterPlugin,
    [radioFilterName as any]: radioFilterPlugin,
};

/**
 * A custom hook that creates a stateful filter for managing search text.
 * It leverages the `useGuiFilters` hook and focuses on the specified search text filter name.
 *
 * @constant
 * @function
 * @returns {ReturnType<typeof makeUseStateChild>} A stateful filter hook for search text.
 */
export const useSearchTextFilter =
    makeUseStateChild(useGuiFilters, lb => lb.focusOn(searchTextName));

export function cleanFilters<Filters extends Record<string, any>>(filters: Filters, filterPlugins: FiltersPlugins<Filters>): Filters {
    const cleanedFilters: Filters = {} as Filters;
    Object.keys(filters).forEach(key => {
        const k: keyof Filters = key;
        const plugin = filterPlugins[k];
        if (plugin && plugin.deleteWhenClean === false) {
            cleanedFilters[k] = filters[k];
        }
    });
    console.log('cleanFilters', filters, filterPlugins, cleanedFilters)
    return cleanedFilters;


}